<a class="card clickable" [attr.data-testid]="'guideline-preview-card_container-' + guideline.uniqueId" [routerLink]="guideline.linkUrl">
  @if (!guideline.imageUrl) {
    <div class="more">
        <a
          *ngxPermissionsOnly="[permissions.viewManagePage]"
          [attr.data-testid]="'guideline-preview-card_button-detailed-view-' + guideline.uniqueId"
          [routerLink]="'/manage/guideline/' + guideline.uniqueId"
          [ttTooltip]="'DetailView' | transloco"
          (click)="$event.stopPropagation()">
          <button emphasis="minimal" size="small" ttButton variant="primary">
            <mat-icon [icon]="'external-link'" [iconSize]="16" />
          </button>
        </a>

      <a
        [attr.data-testid]="'guideline-preview-card_button-preview-' + guideline.uniqueId"
        [routerLink]="'/guideline/preview/' + guideline.uniqueId"
        [ttTooltip]="'Preview' | transloco"
        (click)="$event.stopPropagation()">
        <button emphasis="minimal" size="small" ttButton variant="primary">
          <mat-icon [icon]="'eye'" [iconSize]="16" />
        </button>
      </a>
    </div>
  }
  <div class="heading">
    <h3 class="tt-guideline-preview-card_title" [attr.data-testid]="'guideline-preview-card_info-title-' + guideline.uniqueId">{{ guideline.title }}
      @if (guideline.guidelineOrigin === GuidelineOrigin.IMPORTED) {
        <mat-icon
          [icon]="'import'"
          [iconSize]="16"
          [ttTooltip]="'GuidelineManagePage.Imported' | transloco" />
      }
      @if (guideline.guidelineOrigin === GuidelineOrigin.SHARED) {
        <mat-icon
          [icon]="'graph'"
          [iconSize]="16"
          [ttTooltip]="'GuidelineManagePage.Shared' | transloco" />
      }
    </h3>
    @if (showOwner && guideline.owner) {
      <span class="secondary-text" [attr.data-testid]="'guideline-preview-card_info-owner-' + guideline.uniqueId">
        {{ 'GuidelineOwner' | transloco }}: {{ guideline.owner | name }}
      </span>
    }
    @if (!showOwner && guideline.editor) {
      <span class="secondary-text" [attr.data-testid]="'guideline-preview-card_info-editor-' + guideline.uniqueId">
        {{ 'LastEdit' | transloco }}: {{ guideline.editor | name }}
      </span>
    }
  </div>
  <div class="footer">
    <div class="secondary-text" [attr.data-testid]="'guideline-preview-card_info-version-' + guideline.uniqueId">
      {{ 'Version' | transloco }} {{ guideline.version }}
    </div>
    @if (guideline.imageUrl) {
      <img alt="organisation-image" class="organisation-image" [src]="guideline.imageUrl" />
    } @else {
      @if (guideline.state !== null) {
        <common-chip
          [attr.data-testid]="'guideline-preview-card_info-state' + guideline.uniqueId"
          [variant]="GuidelineState[guideline.state] | lowercase">
          {{ 'GuidelineStatus.' + GuidelineState[guideline.state] | transloco }}
        </common-chip>
      }
    }
  </div>
</a>
